export default __webpack_public_path__ + "static/media/April2012.6c75424a.png";